/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import wx from 'weixin-js-sdk'
import Axios from 'axios'
const wxApi = {
  /**
  * [wxRegister 微信Api初始化]
  * @param  {Function} callback [ready回调函数]
  */
	wxRegister (option) {
    // 这边的接口请换自己的
		let formdata = new FormData();
		formdata.append('user_id', localStorage.getItem('userId'));
		formdata.append('token', localStorage.getItem('token'));
		formdata.append('page_url', option.link);
    Axios.post('http://sls.zhishen.net.cn/api/Wechatshare/getShareInfo', formdata).then((res) => {
			wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appid, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名
        jsApiList: [
					'onMenuShareAppMessage',
					'onMenuShareTimeline',
					//'onMenuShareQQ',
					//'onMenuShareQZone'
				] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
    }).catch((error) => {
      console.log(error)
    })
    wx.ready(function() {
      wx.onMenuShareTimeline({
        title: option.title, // 分享标题
        link: option.link, // 分享链接
        imgUrl: option.imgUrl, // 分享图标
        success () {
          // 用户成功分享后执行的回调函数
          console.log('success')
        },
        cancel () {
          // 用户取消分享后执行的回调函数
          console.log('fail')
        }
      });
			wx.onMenuShareAppMessage({
			  title: option.title, // 分享标题
			  desc: option.desc, // 分享描述
			  link: option.link, // 分享链接
			  imgUrl: option.imgUrl, // 分享图标
			  success () {
			    // 用户成功分享后执行的回调函数
			    console.log('success')
			  },
			  cancel () {
			    // 用户取消分享后执行的回调函数
			    console.log('fail')
			  }
			});
    })
  }
}
export default wxApi


// WEBPACK FOOTER //
// ./src/common/wxapi.js